import React, { useEffect, useState } from 'react'

import {
  Box,
  CircularProgress,
  Typography,
  makeStyles,
} from '@material-ui/core'
import clsx from 'clsx'

import styles from './styles'
import helpers from 'helpers'

const useStyles = makeStyles(styles)

const PocketImage = ({ reference, qrcode, company }) => {
  const [qrcodeLoaded, setQrCodeLoaded] = useState(false)

  const classes = useStyles()

  const companyNameSize = company?.name.length >= 100
  const currentYear = new Date().getFullYear()

  useEffect(() => {
    if (!qrcode) {
      setQrCodeLoaded(false)
      return
    }

    const img = new Image()
    img.onload = () => {
      setQrCodeLoaded(true)
    }
    img.onerror = () => {
      setQrCodeLoaded(true)
    }
    img.src = qrcode
    // eslint-disable-next-line
  }, [qrcode])

  return (
    <div ref={reference}>
      <Box className={classes.cardBackground}>
        <Box className={classes.cardContainer}>
          <Box className={classes.BoxQrcode}>
            {qrcodeLoaded ? (
              <img
                loading="lazy"
                className={classes.qrcode}
                alt="qrcode"
                src={qrcode}
              />
            ) : (
              <Box
                width={90}
                height={90}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <CircularProgress size={50} color="primary" />
              </Box>
            )}
          </Box>
          <Box className={classes.boxCompany}>
            <Box className={classes.dateContainer}>
              <Typography className={classes.date}>{currentYear}</Typography>
            </Box>
            <Box className={classes.contextCompany}>
              <Typography
                variant="h4"
                className={clsx(classes.companyName, {
                  [classes.companyNameLong]: companyNameSize,
                })}
              >
                {company?.name.toUpperCase()}
              </Typography>
              <Typography variant="body2">
                {helpers.company.documentType(company)}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  )
}

export default PocketImage
